import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Popover } from "antd";
import { I18N_NS } from "Config/i18n";
import { useTranslation } from "react-i18next";

export const RemovedUsersNote = () => {
  const { t } = useTranslation(I18N_NS.PROJECT);
  return (
    <Popover
      content={
        <div style={{ width: 250 }}>
          {t("There are rights set for removed users. Please check if any changes in rights management are necessary.")}
        </div>
      }
    >
      <span className="pointer color-red">
        <FontAwesomeIcon fixedWidth size="2x" icon={["far", "exclamation-circle"]} />
      </span>
    </Popover>
  );
};
